import React from "react";

const CpPreReleaseRibbon = ({ enable = false }) => {
    if (!enable) return null;

    return (
        <div className="absolute w-full h-[120px] overflow-hidden">
            <div className="absolute right-16 top-0 h-16 w-16 text-white">
                <div
                    className="absolute left-[-10px] top-[32px] w-[180px] transform rotate-45
            bg-gray-50 text-center text-primary-500 font-semibold py-1"
                >
                    Pre-Release
                </div>
            </div>
        </div>
    );
};

export default CpPreReleaseRibbon;
